import { createContext } from 'react';
import { lightTheme } from '@stylesheets/theme';

export type ThemePreference = 'SYSTEM' | 'light' | 'dark';

export interface ThemeContextType {
  theme: typeof lightTheme;
  themeName: 'light' | 'dark';
  themePreference: ThemePreference;
  setThemePreference: (pref: ThemePreference) => void;
}

export const ThemeCtx = createContext<ThemeContextType | undefined>(undefined);
